
export default class MapboxLayer {
  constructor(id, type, minZoom, maxZoom, paint, layout, filter, extrusion, nameExtension, imageSource, chartOptions) {
    this.id = `${id}${(nameExtension === undefined) ? '' : `-${nameExtension}`}-${type.replace('-', '')}`;
    this.type = type;
    this.source = id;
    this.minZoom = (minZoom === undefined) ? 0 : minZoom;
    this.maxZoom = (maxZoom === undefined) ? 17 : maxZoom;

    if (type === 'circle') {
      this.filter = ['==', '$type', 'Point'];
      this.filter = ['all', ['!has', 'point_count'], this.filter];
      if (filter != null) {
        this.filter = ['all', this.filter, filter];
      }
    }

    if (type === 'line' || type === 'fill') {
      this.filter = ['!=', '$type', 'Point'];
      if (filter != null) {
        this.filter = filter;
      }
    }
    if (type === 'symbol') {
      if (filter != null) {
        this.filter = filter;
      }
    }

    if (nameExtension === 'cluster') {
      this.filter = ['all', ['has', 'point_count']];
    }
    // if (type === 'fill-extrusion') {
    //   this.paint.set('fill-extrusion-height') = ;
    // }

    if (paint !== undefined) {
      this.paint = paint;
    }

    if (layout !== undefined) {
      this.layout = layout;
    }
    if (imageSource !== undefined) {
      this.imageSource = imageSource;
      this.layout['icon-image'] = imageSource;
    }
    if (chartOptions !== undefined) {
      this.chartOptions = chartOptions;
    }
  }
}
